/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../../APIClient.jsx";
import History from "../History.jsx";
import Tooltip from "../Tooltip.jsx";

class LastErrors extends Component {
    constructor() {
        super();
        this.state = {
            stateHistory: []
        }
    }

    async fetchData() {
        let {name} = this.props

        let tableName = `STATE_${name}`
        let result = await Database.table(tableName, "app").filter([{column: "state", value: "broken"}, {
            column: "time",
            type: "order",
            orderDirection: "DESC"
        }], 0, 100)
        this.setState({stateHistory: result.recordset.sort((a, b) => (b.time - a.time))})
    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.name !== this.props.name) {
            this.fetchData()
        }
    }


    render() {
        let {stateHistory} = this.state
        return (
            <div>
                <History elements={stateHistory.map(state => {
                    return ({
                        timestamp: state.time,
                        text: <span>
                            <span
                                className="font-medium text-gray-900"> {state.elementId}</span>
                             <div className={"text-red-400 space-x-3 flex"}>{(state.errors ?? []).map(error => {
                                 return <Tooltip text={error.message}
                                                 className={"border rounded border-red-500 p-1 my-1 hover:bg-red-50 cursor-pointer"}>
                                     <span>{error.code}</span>

                                 </Tooltip>
                             })}</div>
                        </span>
                    })
                })}/>

            </div>
        );
    }
}

LastErrors.propTypes = {};

LastErrors.defaultProps = {};


export default LastErrors;